import { useState, useMemo } from 'react'
import { useFirestoreGeneralOrderBy, useFirestoreID } from '../../firebase/useFirestore'
import Modal from '../common/Modal'
import MeasureMoment from './MeasureMoment'
import TasksModalContent from './TasksModalContent'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'

/**
 * Meetmomenten van een onderzoek inplannen voor een deelnemer of huishouden.
 *
 * @param {object} props
 * @param {boolean} props.modalOpen - Of het venster open staat
 * @param {(open: boolean) => void} props.setModalOpen - Opent of sluit het venster
 * @param {string} props.researchID - Het onderzoek waarvan de meetmomenten getoond worden
 * @param {string} [props.personaID] - De deelnemer of het huishouden waarvoor ingepland wordt
 * @param {string} [props.personaName] - Naam van die deelnemer of dat huishouden, voor de kop
 */
const ScheduleModal = ({ modalOpen, setModalOpen, researchID, personaID = '', personaName = '' }) => {
    // State
    const [view, setView] = useState('moments') // 'moments' | 'tasks'
    const [selectedMoment, setSelectedMoment] = useState(null)

    // Firestore
    const measureMomentsRaw = useFirestoreGeneralOrderBy(
        'MeasureMoments',
        'ResearchID',
        researchID || '',
        'Position',
        'asc'
    )
    const measureMoments = useMemo(() => (measureMomentsRaw || []).filter((m) => !m.Deleted), [measureMomentsRaw])
    const researchDocs = useFirestoreID('Research', researchID || '')
    const questionnaireID = useMemo(() => researchDocs?.[0]?.QuestionnaireID || '', [researchDocs])

    const handleClose = () => {
        setView('moments')
        setSelectedMoment(null)
        setModalOpen(false)
    }

    const handleScheduleMoment = (moment) => {
        setSelectedMoment(moment)
        setView('tasks')
    }

    const handleBack = () => {
        setView('moments')
        setSelectedMoment(null)
    }

    const content = view === 'moments'
        ? (
            // Het onderzoek mee, zodat verslepen of verwijderen de kwalificeringsvragen
            // voor de huidige vragenlijst herberekent en niet voor de vragenlijst die
            // bij het aanmaken op het meetmoment stond (codereview /complete 2026-10-28).
            <MeasureMoment measureMoments={measureMoments} research={researchDocs?.[0]} onSchedule={handleScheduleMoment} personaID={personaID} />
        )
        : (
            <div>
                <button className='button-simple' onClick={handleBack}>
                    <ArrowBackOutlinedIcon fontSize='small' /> Terug
                </button>
                <TasksModalContent
                    measureMomentID={selectedMoment?.ID}
                    momentTitle={selectedMoment?.Title || ''}
                    type='measureMoment'
                    personaID={personaID}
                    personaName={personaName}
                    researchID={researchID}
                    questionnaireID={questionnaireID}
                />
            </div>
        )

    const header = view === 'moments'
        ? 'Inplannen'
        : `Inplannen: ${selectedMoment?.Title || ''}`

    return (
        <Modal
            modalOpen={modalOpen}
            setModalOpen={handleClose}
            confirm={handleClose}
            pageHeader={header}
            content={content}
        />
    )
}

export default ScheduleModal
